import { useMemo } from "react";
import { useApi } from './useApi.ts';
import { forecastApi } from '../api/apiClient.ts';

interface ForecastParams {
  latitude: string | number;
  longitude: string | number;
  current_weather?: boolean;
}

interface CurrentWeather {
  temperature: number;
  windspeed: number;
  winddirection: number;
  weathercode: number;
  time: string;
}

interface ForecastResponse {
  current_weather?: CurrentWeather;
  generationtime_ms: number;
}

// Validate forecast parameters
const validateForecastParams = (params: ForecastParams): boolean => {
  const lat = Number(params.latitude);
  const long = Number(params.longitude);
  
  return !isNaN(lat) && !isNaN(long) && 
    lat >= -90 && lat <= 90 && 
    long >= -180 && long <= 180;
};

export const useForecast = () => {
  const options = useMemo(() => ({
    initialData: { generationtime_ms: 0 },
    debounceTime: 500,
    validateInput: validateForecastParams
  }), []);
  return useApi<ForecastResponse, ForecastParams>(forecastApi, options);
};